import styled from 'styled-components'
import Colors from '../../theme/colors'
import Fonts from '../../theme/fonts'

export const Label = styled.label`
  margin: 0;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  color: ${Colors.Primary.GreyText};
  font-size: ${Fonts.fontSizes.p16};
  font-family: ${Fonts.fontFamilies.Inter};
`

export const Content = styled.div`
  width: 100%;
  background: ${Colors.Primary.White};
  margin: 10px 0;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Message = styled.div<{ isValid: boolean }>`
  font-family: ${Fonts.fontFamilies.Inter};
  color: ${({ isValid }) => (!isValid ? Colors.Action.ErrorRed : Colors.Action.SuccessGreen)};
  min-height: 16px;
`
